import { MappedImage } from "src/utils/fw"
import podcastHub from "../modal/podcastHub"
import recentReleases from "../modal/recentReleases"
import riskManagement from "../modal/riskManagement"
import peopleManagement from "../modal/peopleManagement"
import complianceGovernance from "../modal/complianceGovernance"
import { benchmarksLinks, futureResearch, iramT, isfServices, magazineRackLeft, magazineRackR, qiraLinks, SOGP, supplierSec, ThreadHorizon } from "../modal/explorationVideos"
import { textModal } from "../booths/common"

const ImageModal = (content, closeTop = null, closeRight = null) => ({
    modalOverrides: {
        dismissHTML: " ",
        dismissStyle: {
            color: "#fff",
            fontSize: "25px",
            top: closeTop || "4%",
            right: closeRight || "17.1%",
            width: "2%",
            height: "4%"
        }
    },
    modal: content
})

const listenHere = {
    width: "5.8%",
    height: "18.1%",
    left: "64%",
    top: "51.8%",
    label: "Discover the ISF Podcast library",
    ...ImageModal(<MappedImage roomName="ExplorationZone" imageURL="https://assets.swoogo.com/uploads/full/2138562-63500c547ff84.png"
        links={podcastHub}
    />)
}

const risk = {
    width: "8.8%",
    height: "25.1%",
    left: "59.1%",
    top: "36%",
    label: "Access ISF research and further information",
    hoverMessage: "Access ISF research and further information",
    ...ImageModal(<MappedImage roomName="ExplorationZone" imageURL="https://assets.swoogo.com/uploads/full/2138892-63501b563c010.png" links={riskManagement} />, "6%", "20.4%")
}

const recent = {
    width: "8.8%",
    height: "25.1%",
    left: "32.1%",
    top: "36%",
    hoverMessage: "Access the latest ISF research",
    label: "Access the latest ISF research",
    ...ImageModal(<MappedImage roomName="ExplorationZone" imageURL="https://assets.swoogo.com/uploads/full/2138945-63501da029f8e.png" links={recentReleases} />, "6%", "20.4%")
}

const management = {
    ...ImageModal(<MappedImage roomName="ExplorationZone" imageURL="https://assets.swoogo.com/uploads/full/2141163-6350587c95cd1.png" links={peopleManagement} />, "6%", "20.4%"),
    width: "8.8%",
    height: "25.1%",
    left: "41.1%",
    top: "36%",
    label: "Access ISF research and further information",
    hoverMessage: "Access ISF research and further information"
}

const compliance = {
    ...ImageModal(<MappedImage roomName="ExplorationZone" imageURL="https://assets.swoogo.com/uploads/full/2144241-63519bb1822bb.png" links={complianceGovernance} />, "6%", "20.4%"),
    width: "8.8%",
    height: "25.1%",
    left: "50.1%",
    top: "36%",
    hoverMessage: "Access key information related to your ISF Membership",
    label: "Access key information related to your ISF Membership"
}

const services = {
    width: "12.4%",
    height: "15.1%",
    left: "69.1%",
    top: "37.7%",
    label: "See the suite of ISF Services avaliable to organisations ",
    ...ImageModal(<MappedImage roomName="ExplorationZone" imageURL="https://assets.swoogo.com/uploads/full/2144284-63519edecd3e3.png" links={isfServices} />, "21.5%", "29%"),
}

const benchmarks = {
    width: "17%",
    height: "20.1%",
    left: "1.1%",
    top: "15.7%",
    label: "Discover how Benchmark can assess your current security status",
    ...ImageModal(<MappedImage roomName="ExplorationZone" imageURL="https://assets.swoogo.com/uploads/full/2144645-6351ae44d04a8.png" links={benchmarksLinks} />, "13.5%", "21.7%")
}

const future = {
    width: "12.6%",
    height: "16.1%",
    left: "68.8%",
    top: "20.7%",
    label: "Got a core topic you'd like us to research? Submit your ideas through the Future Research Hub",
    ...ImageModal(<MappedImage roomName="ExplorationZone" imageURL="https://assets.swoogo.com/uploads/full/2145006-6351cb5b9742f.png" links={futureResearch} />, "13.5%", "21.7%")
}

const QIRA = {
    width: "17%",
    height: "18.1%",
    left: "81.8%",
    top: "16.7%",
    label: "Dicover how the QIRA product suite can help you quantify risk",
    ...ImageModal(<MappedImage roomName="ExplorationZone" imageURL="https://assets.swoogo.com/uploads/full/2182962-636aad7b2af55.png" links={qiraLinks} />, "13.5%", "21.7%")
}

const iramtwo = {
    width: "12.6%",
    height: "16.1%",
    left: "18.3%",
    top: "20.7%",
    label: "Discover how the IRAM2 methodology can help you conduct risk assessments",
    ...ImageModal(<MappedImage roomName="ExplorationZone" imageURL="https://assets.swoogo.com/uploads/full/2182961-636aad7a1f225.png" links={iramT} />, "13.5%", "21.7%")
}

const supplier = {
    width: "12.6%",
    height: "15.1%",
    left: "18.3%",
    top: "37.7%",
    label: "Discover how Supply Security can help you track existing supplier relationships",
    ...ImageModal(<MappedImage roomName="ExplorationZone" imageURL="https://assets.swoogo.com/uploads/full/2182965-636aad7cbcbc8.png" links={supplierSec} />, "13.5%", "21.7%")
}

const sogp = {
    width: "16.6%",
    height: "18.1%",
    left: "1.3%",
    top: "36.7%",
    label: "Discover how the Standard of Good Practice framework can support your organisation",
    ...ImageModal(<MappedImage roomName="ExplorationZone" imageURL="https://assets.swoogo.com/uploads/full/2182964-636aad7bd8b1c.png" links={SOGP} />, "13.5%", "21.7%")
}

const threadHorizon = {
    width: "16.7%",
    height: "17.1%",
    left: "82%",
    top: "36.7%",
    label: "Learn about our plans for Threat Horizon this year, and what the future holds for our flagship research",
    ...ImageModal(<MappedImage roomName="ExplorationZone" imageURL="https://assets.swoogo.com/uploads/full/2145085-6351d260cef6e.png" links={ThreadHorizon} />, "13.5%", "21.7%"),
}

const leftMagazineRack = {
    width: "5.8%",
    height: "29.1%",
    left: "11.3%",
    top: "54.7%",
    label: "Find out more about the services included in your ISF Membership",
    ...ImageModal(<MappedImage roomName="ExplorationZone" imageURL="https://assets.swoogo.com/uploads/full/2165167-63600a39342fd.png" links={magazineRackLeft} />, "14.6%", "26.8%"),
}

const rightMagazineRack = {
    width: "5.8%",
    height: "29.1%",
    left: "82.8%",
    top: "54.7%",
    label: "The latest cyber security trends and how the ISF can help",
    ...ImageModal(<MappedImage roomName="ExplorationZone" imageURL="https://assets.swoogo.com/uploads/full/2154680-6358452466165.png" links={magazineRackR} />, "11%", "29%"),
}

const tellUs = {
    width: "4.8%",
    height: "17.1%",
    left: "31.6%",
    top: "52%",
    label: "Let us know what is important to you with this quick survey",
    modalOverrides: textModal("fit-content"),
    modal: <h1>The surveys are now closed.</h1>
}

const chatWithUs = {
    width: "7.8%",
    height: "23.1%",
    left: "46.6%",
    top: "60%",
    label: "Have a question about ISF research, products or services? Talk to us here",
    isExternal: false,
    modalOverrides: textModal("fit-content"),
    modal: <h1>The chat feature is now closed.</h1>
}


export const body = {
    background: "https://assets.swoogo.com/uploads/full/2178460-636911afbf470.jpg",
    name: "Exploration Zone",
    links: [
        recent,
        risk,
        compliance,
        management,
        listenHere,
        services,
        benchmarks,
        future,
        QIRA,
        iramtwo,
        supplier,
        sogp,
        threadHorizon,
        leftMagazineRack,
        rightMagazineRack,
        tellUs,
        chatWithUs,
        {
            width: "8.2%",
            height: "15.7%",
            left: "46%",
            top: "82.6%",
            label: "Back to Atrium",
            href: "/Atrium"
        }
    ]
}

export const location = "/Exploration-Zone"